import React, { FC, useCallback, useState } from 'react';
import { SimpleCard } from '@code/innovance-react-ui-kit';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { SubMenuRoutes, MenuIds } from 'src/front/routes/paths';
import { BREAK_POINTS } from 'src/front/constant';
import { MenuItem, Menu } from 'src/front/api/generated';
import { useSubMenuState } from 'src/front/contexts/SessionContext';
import { Session, updateHeaderConfig } from 'src/front/api/apiInstance';
import SearchBar from 'src/front/components/SearchBar';

const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;

  & > div {
    box-sizing: border-box;
    margin: 1rem 0.25em;

    flex: 1 0 500px;

    max-width: calc(25% - 1em);
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.TABLET}) and (min-width: ${BREAK_POINTS.MIN
      .PHONE}) {
    & > div {
      max-width: calc(50% - 1em);
    }
  }

  @media screen and (max-width: ${BREAK_POINTS.MAX.PHONE}) {
    & > div {
      max-width: 100%;
    }
  }
`;

const StyledSimpleCard = styled(SimpleCard)`
  margin: 0 40px 40px 0;
`;
interface Props {
  isCallCenter?: boolean;
}
const Application: FC<Props> = ({ isCallCenter }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const unfilteredApplications = useSubMenuState(
    isCallCenter ? MenuIds.CALL_CENTER : MenuIds.APPLICATION
  );
  const [applications, setApplications] = useState<Menu[]>(unfilteredApplications);

  const goToApplicationDetail = (menuId: string) => async () => {
    const { data, headers } = await Session.clearSessionData({ menuID: menuId });
    if (data.result !== 'OK') return;
    updateHeaderConfig(data.sessionID, headers.authorization);
    history.push(SubMenuRoutes[menuId]);
  };

  const getApplications = useCallback(
    async (searchText = '') => {
      setApplications(
        unfilteredApplications.filter((item) => t(item.name).toUpperCase().includes(searchText))
      );
    },
    [t, unfilteredApplications]
  );

  const handleSearch = (searchText: string): void => {
    if (searchText !== '') {
      getApplications(searchText);
    } else {
      setApplications(unfilteredApplications);
    }
  };

  return (
    <>
      <SearchBar
        minimumSearchCharacters={2}
        noResult={applications.length === 0}
        onChange={handleSearch}
      />
      <CardContainer>
        {applications.map((item: MenuItem) => (
          <StyledSimpleCard
            key={item.menuID}
            onClick={goToApplicationDetail(item.menuID || '')}
            text={t(item.description || '')}
            title={t(item.name)}
          />
        ))}
      </CardContainer>
    </>
  );
};

export default Application;
